import css from '../dashboardTile.module.css'
import PlusIcon from '@/assets/icons/plus.svg?react'
import CreateDashboardModal from '@/pages/Dashboards/components/Modals/CreateDashboardModal'
import { useState } from 'react'
import { IDashboardGroup } from '@/pages/Dashboards/dashboards.types.ts'

interface IProps {
  groupId: IDashboardGroup['id']
}

const CreateDashboardTile = (props: IProps) => {
  const [createDashboardModalOpen, setCreateDashboardModalOpen] = useState(false)

  return (
    <>
      <div className={css.createTileWrapper} onClick={() => setCreateDashboardModalOpen(true)}>
        <div className={css.plusIconWrapper}>
          <PlusIcon className={css.plusIcon} />
        </div>
        <p className="text-nm">Новый дашборд</p>
      </div>
      <CreateDashboardModal
        open={createDashboardModalOpen}
        onClose={() => setCreateDashboardModalOpen(false)}
        groupId={props.groupId}
      />
    </>
  )
}

export default CreateDashboardTile
